import React, { Component } from 'react';
import TabPanelPunch from './TabPanelPunch'
import { withNamespaces } from 'react-i18next';
import i18next from 'i18next';
import styles from '../../styles/punch.module.css';
import { isAuthenticated } from '../../actions/authentication';
import { withCookies } from 'react-cookie';
import { RenewToken } from '../../utils/token';
import { ChatContext } from '@/ChatProvider';

class Punch extends Component {

    constructor(props) {
        super(props);

        this.state = { authenticated: false }
    }

    componentDidMount() {
        this.handleTitle();
        this.handleToken();
    }

    async handleToken() {
        await RenewToken(this.props);

        isAuthenticated().then((result) => {
            this.setState({ authenticated: result });
            this.context.setIsAuthenticated(result);
        });
    }

    handleTitle() {
        this.props.onLoadTitle(i18next.t('menu:punch'));
    }

    render() {
        return (
            this.state.authenticated &&  <div className={styles.rootPunch}>
                <TabPanelPunch />
            </div>
        );
    }
}

Punch.contextType = ChatContext;
export default withNamespaces(['menu'], { wait: true })(withCookies(Punch));